
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gGxWFs9ZUTYJVi_qESzuV7ugSkraJYwr6v_45f0ET4WecgMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexMv7Cab2lZJD1Ghgpv4sypNM3JvuMi1ccY4_7FkzGq54Meta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search9PJGXeUIDY3YWgrXMUobZMMqdXHOdSa4TVscFet4jXwMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexZTAYXQYOhU0QFzFFSFFDSGFRL42EL75eVHdfwRjnnksMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93bWS3mVsNES1crUKU32Rf0N6elfFR_Kq3K0AkFuxtW2cMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexShfTxcmNczoDp2de2i6CCaDkvK7wUKOr0LeKffcCNEwMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93luNOIYteEFscbWQQCEPtUlpURRIH_QRipJVC5PW_45tBgMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indextZ2mDAqMAJoqTdZWbh6VJ_t4ORA9BPghdSw6NPbZakAMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93xoYICinz4uKewUn6nS8y_45oCIIgHIOEiu_SuM59YxZlcMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexBfKo8qQ87XfbbHXIoeWuI0QNoF7SgvSc8MU9wcO4okEMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index6scWYfLlDZCDBBBv3KoLwrL1BX3VycgSWl3fwQ0EChEMeta } from "/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexShfTxcmNczoDp2de2i6CCaDkvK7wUKOr0LeKffcCNEwMeta || {},
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indextZ2mDAqMAJoqTdZWbh6VJ_t4ORA9BPghdSw6NPbZakAMeta || {},
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexBfKo8qQ87XfbbHXIoeWuI0QNoF7SgvSc8MU9wcO4okEMeta || {},
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index6scWYfLlDZCDBBBv3KoLwrL1BX3VycgSWl3fwQ0EChEMeta || {},
    component: () => import("/codebuild/output/src1687298151/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]